(function(angular){
	'use strict';
	
	angular
		.module('recurringInvestmentReviewModule', 
		[
			'apiModule',
			'coreModule',
			'formValidationModule',
			'progressIndicatorModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);